import {Layout} from '../../../layout'
import {Text} from '../../../text'
import {useBasicTableContext} from '../../context'

export const EndOfContentPlaceholder = () => {
	const {basicTableT} = useBasicTableContext()

	return (
		<Layout className="end-of-content-placeholder" padding="48 0" horizontal="center" direction="vertical" width="full" grow>
			<Text noTextSelect color="dark-grey" bold>
				{basicTableT('end_of_content.title')}
			</Text>
			<Text noTextSelect color="dark-grey">
				{basicTableT('end_of_content.subtitle')}
			</Text>
		</Layout>
	)
}
